module.exports = __webpack_public_path__ + "static/media/start.a14c7998.svg";